module.exports = __webpack_public_path__ + "flaticon.dd412130988fc3643582";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/scss/multi-sports/flaticon.woff2
// module id = ../../../../../src/scss/multi-sports/flaticon.woff2
// module chunks = styles